import React                from 'react';
import CSSModules           from 'react-css-modules';
import { reduxForm }        from 'redux-form';

import style from './style.scss';

import eventRepository     from '../../services/events';
import FormSubmitter       from '../../services/formSubmitter';
import dateTimeDecorator   from '../../services/dateTimeDecorator';

import Button               from '../Button';
import Input                from '../Input';
import InlineError          from '../InlineError';
import InputGroup           from '../InputGroup';
import Label                from '../Label';
import SelectBox            from '../SelectBox';
import Checkbox             from '../Checkbox';
import InputSection         from '../InputSection';
import TimetableSelect      from '../TimetableSelect';
import VenueSelect          from '../VenueSelect';
import PriceInputs          from '../PriceInputs';
import StartEndDateInputs   from '../StartEndDateInputs';
import FontIcon             from "../FontIcon";
import PriceInput           from "../PriceInput";
import MultipleDaysEventsInputs from '../MultipleDaysEventsInputs';

import Typeahead from "pattern-library/dist/js/components/Typeahead";
import TypeaheadResult from "pattern-library/dist/js/components/TypeaheadResult";

import * as presenterActions from "../../actions/presenterList";
import * as resourcePackActions from "../../actions/resourcePackList";

class EventForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            multipleDaysEventsSelected: false,
            multipleDaysEventsLists: null,
            showVenueField: true,
            presenterSearch: "",
            packSearch: "",
            assignedPresenters: []
        }
    }

    componentDidMount() {

        this.setState({multipleDaysEventsSelected: false});

        if (this.props.formMode === 'add') {

            this._setDefaultCourseValues(this.props.courses.courses[0]);
            this.setState({
                ...this.state,
                showVenueField: this.props.courses.courses[0].type !== "webinar"
            });

        } else if (this.props.formMode === 'edit') {

            this.props.initializeForm(this.props.eventToEdit);
            this.props.fields.override_price.onChange(!!this.props.eventToEdit.overridden_price);
            this.setState({
                ...this.state,
                multipleDaysEventsSelected: this.props.eventToEdit.multiple_days,
                showVenueField: this.props.eventToEdit.course.type !== "webinar"
            });
        }

        this.setState({multipleDaysEventsLists: null});
    }

    _presenterChecked(presenter, presentersField) {

        presentersField.addField(presenter);
    }

    _presenterUnchecked(fieldIndex, presentersField) {

        presentersField.removeField(fieldIndex);
    }

    _resourcePackChecked(pack, resourcePacksField) {

        resourcePacksField.addField(pack);
    }

    _resourcePackUnchecked(fieldIndex, resourcePacksField) {

        resourcePacksField.removeField(fieldIndex);
    }

    _getCreateEventMethod(event) {

        return eventRepository.create(this._formatEvent(event));
    }

    _getUpdateEventMethod(event) {

        return eventRepository.update(this._formatEvent(event));
    }

    _formatEvent(params) {

        const event = dateTimeDecorator.formatStartEndDates(params);

        if (event.multiple_days) {

            return {
                ...event,
                multiple_days_events: event.multiple_days_events.map(e => {
                    return {
                        ...e,
                        timetable_id: e.timetable_id || null
                    }
                })
            };
        }

        return event;
    }

    _populateDefaultCourseValues(eventField) {

        const selectedCourse = this._getSelectedCourse(eventField.target.value);

        if(selectedCourse.type === "webinar"){
            this.setState({
                ...this.state,
                showVenueField: false
            });
        }else{
            this.setState({
                ...this.state,
                showVenueField: true
            });
        }

        this._setDefaultCourseValues(selectedCourse);

        return this.props.fields.course_id.onChange(eventField);
    }

    _getSelectedCourse(courseId) {
        return this.props.courses.courses.find((course) => {
            return course.id === parseInt(courseId);
        });
    }

    _updateMultipleDaysEventsSelection() {

        if (!this.state.multipleDaysEventsSelected && this.props.values.multiple_days_events.length === 0) {

            this._updateMultipleDaysEventsLists({
                startDate: null,
                startTime: null,
                endDate: null,
                endTime: null,
                timetableId: null
            });
        }

        this.setState({multipleDaysEventsSelected: !this.state.multipleDaysEventsSelected});
    }

    _updateMultipleDaysEventsLists(newEvent) {

        this.props.fields.multiple_days_events.addField(newEvent);
    }

    _removeMultipleDaysEventsLists() {

        const index = this.props.fields.multiple_days_events.length;

        this.props.fields.multiple_days_events.removeField(index - 1)

    }

    _setDefaultCourseValues(course) {

        if(this.state.multipleDaysEventsSelected){
            this._updateMultipleDaysEventsSelection();
        }

        this.props.initializeForm({
            ...this.props.values,
            'course_id': course.id,
            'private_price': course.private_price,
            'public_price': course.public_price,
            'override_price': !!course.overridden_price,
            'overridden_price': course.overridden_price,
            'timetable_id': course.timetable_id,
            'venue_id': this.props.venues[0].id,
            'presenters': course.presenters,
            'resource_packs': course.resource_packs,
            'multiple_days_events': [],
            'multiple_days': false
        });
    }

    _resetOverriddenPrice(e) {
        if (e.target.checked) {
            this.props.fields.overridden_price.onChange('0.00');
        } else {
            this.props.fields.overridden_price.onChange(null);
        }
        this.props.fields.override_price.onChange(e.target.checked);
    }

    _handleSearch(searchTerm){
        this.setState({
            ...this.state,
            presenterSearch: searchTerm
        });
        this.props.getPresenters(searchTerm);
    }

    _handlePackSearch(searchTerm){
        this.setState({
            ...this.state,
            packSearch: searchTerm
        });
        this.props.getPacks(searchTerm);
    }

    render() {

        const {
            fields: {
                reference_code,
                start_date,
                start_time,
                end_date,
                end_time,
                course_id,
                timetable_id,
                venue_id,
                private_price,
                public_price,
                max_delegates,
                resource_code,
                presenters,
                resource_packs,
                multiple_days_events,
                multiple_days,
                override_price,
                overridden_price,
            },
            handleSubmit,
            submitting
        } = this.props;

        const submitSuccess = this.props.submitSuccess;
        
        var formSubmitter = new FormSubmitter({
            create: this._getCreateEventMethod.bind(this),
            update: this._getUpdateEventMethod.bind(this),
            submitSuccess: submitSuccess
        });

        const assignedPresenters = this.props.presenters.filter(presenter => {
            return this.props.fields.presenters.find(presenterFind => {
                return presenterFind.id.value === presenter.id;
            });
        });

        const assignedResourcePacks = this.props.resourcePacks.filter(pack => {
            return this.props.fields.resource_packs.find(packFind => {
                return packFind.id.value === pack.id;
            });
        });

        const trainingCourses = this.props.courses.courses;
        return (
            <form onSubmit={ handleSubmit(formSubmitter.getSubmit(this.props.formMode)) }>

                <InputSection>

                    <InputGroup>

                        <Label isRequired="true">Reference Code</Label>

                        <Input { ...reference_code } errors={ reference_code.error } />

                        <InlineError errors={ reference_code.error } />

                    </InputGroup>

                    <InputGroup>

                        <Label isRequired="true">Course</Label>

                        <SelectBox { ...course_id } onChange={ this._populateDefaultCourseValues.bind(this) } errors={ course_id.error }>

                            {
                                trainingCourses.map((course, index) => {

                                    return (
                                        <option key={ index } value={ course.id }>
                                            { course.name }
                                        </option>
                                    )
                                })
                            }

                        </SelectBox>

                        <InlineError errors={ course_id.error } />

                    </InputGroup>

                    <InputGroup>

                        <Checkbox
                            { ...multiple_days }
                            checked={this.state.multipleDaysEventsSelected}
                            onChange={ this._updateMultipleDaysEventsSelection.bind(this)}
                        />

                        <span>Multiple Days Events</span>

                        <InlineError errors={ multiple_days.error } />

                    </InputGroup>

                    <MultipleDaysEventsInputs
                        startDate={ start_date }
                        startTime={ start_time }
                        endDate={ end_date }
                        endTime={ end_time }
                        multipleDaysEvents={ multiple_days_events }
                        timetables={ this.props.timetables }
                        timetableId={ timetable_id }
                        multipleDaysEventsSelected={this.state.multipleDaysEventsSelected}
                        onAddClick={this._updateMultipleDaysEventsLists.bind(this)}
                        onRemoveClick={this._removeMultipleDaysEventsLists.bind(this)}
                    />

                    {!this.state.multipleDaysEventsSelected && (
                        <StartEndDateInputs startDate={ start_date }
                                        startTime={ start_time }
                                        endDate={ end_date }
                                        endTime={ end_time } />
                    )}

                    {!this.state.multipleDaysEventsSelected && (<InputGroup>

                        <TimetableSelect timetables={ this.props.timetables }
                                         timetableId={ timetable_id } />

                    </InputGroup>)}

                    {this.state.showVenueField && (
                        <InputGroup>

                            <VenueSelect venues={ this.props.venues }
                                         venueId={ venue_id }
                            />

                        </InputGroup>
                    )}

                    {!override_price.value &&
                    <InputGroup>
                        <PriceInputs privatePrice={ private_price } publicPrice={ public_price } />
                    </InputGroup>
                    }

                    {override_price.value &&
                    <InputGroup>
                        <Label isRequired="true">Delegate Price</Label>
                        <PriceInput className={ style['price-input'] } { ...overridden_price } errors={ overridden_price.error } />
                        <InlineError errors={ overridden_price.error } />
                    </InputGroup>
                    }

                    <InputGroup>
                        <Label>
                            <Checkbox { ...override_price} onChange={this._resetOverriddenPrice.bind(this)} />
                            Use Fixed Price Per Delegate
                        </Label>
                        <InlineError errors={ override_price.error } />
                    </InputGroup>

                    <div styleName="max-code-container">

                        <InputGroup className={ style['max-delegates-container'] }>

                            <Label isRequired="true">Maximum Delegates</Label>

                            <Input { ...max_delegates } errors={ max_delegates.error } className={ style['max-delegates-input'] } />

                            <InlineError errors={ max_delegates.error } />

                        </InputGroup>

                        <InputGroup className={ style['access-code-container'] }>

                            <Label>Resource Access Code</Label>

                            <Input { ...resource_code } errors={ resource_code.error } className={ style['access-code-input'] } />

                            <InlineError errors={ resource_code.error } />

                        </InputGroup>

                    </div>

                    <div styleName="presenters-resources-container">

                        <InputGroup>
                            <Typeahead
                                label=""
                                placeholder="Add Presenter..."
                                value={this.state.presenterSearch}
                                onChange={t => this._handleSearch(t)}
                                onSelectResult={selected => this._presenterChecked(selected, presenters)}
                            >
                                {this.props.presenterSearchResults && this.props.presenterSearchResults.map(r => {
                                    return (
                                        <TypeaheadResult
                                            key={r.id}
                                            value={r}
                                        >
                                            {r.name}
                                        </TypeaheadResult>
                                    )
                                })}
                            </Typeahead>

                            {assignedPresenters.map((presenter, index) => (
                                <span className={style['typeahead-presenter']} key={index}>
                                    <span onClick={presenter => this._presenterUnchecked(presenter.id, presenters)}>
                                        <FontIcon className={style['remove-speaker']} iconName="close" />
                                    </span> {presenter.name}
                                </span>
                            ))}

                        </InputGroup>

                        <InputGroup>
                            <Typeahead
                                label=""
                                placeholder="Add Resource Pack..."
                                value={this.state.packSearch}
                                onChange={t => this._handlePackSearch(t)}
                                onSelectResult={selected => this._resourcePackChecked(selected, resource_packs)}
                            >
                                {this.props.resourcePackSearchResults && this.props.resourcePackSearchResults.map(r => {
                                    return (
                                        <TypeaheadResult
                                            key={r.id}
                                            value={r}
                                        >
                                            {r.name}
                                        </TypeaheadResult>
                                    )
                                })}
                            </Typeahead>

                            {assignedResourcePacks.map((pack, index) => (
                                <span className={style['typeahead-presenter']} key={index}>
                                    <span onClick={pack => this._resourcePackUnchecked(pack.id, resource_packs)}>
                                        <FontIcon className={style['remove-speaker']} iconName="close" />
                                    </span> {pack.name}
                                </span>
                            ))}

                        </InputGroup>

                    </div>

                </InputSection>

                <Button disabled={ submitting }
                        autoWidth="true"
                        theme="success"
                        type="submit">

                    <span>Save</span>
                </Button>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'event',
    fields: [
        'id',
        'reference_code',
        'start_date',
        'start_time',
        'end_date',
        'end_time',
        'course_id',
        'timetable_id',
        'venue_id',
        'private_price',
        'public_price',
        'max_delegates',
        'resource_code',
        'multiple_days',
        'multiple_days_events[].id',
        'multiple_days_events[].start_date',
        'multiple_days_events[].start_time',
        'multiple_days_events[].end_date',
        'multiple_days_events[].end_time',
        'multiple_days_events[].timetable_id',
        'presenters[].id',
        'resource_packs[].id',
        'override_price',
        'overridden_price'
    ]
};

function mapStateToProps(state) {

    return {
        ...state.adminEventList,
        presenterSearchResults: state.presenterList.searchResults,
        resourcePackSearchResults: state.resourcePackList.searchResults,
    };
}

function mapDispatchToProps(dispatch) {

    return {
        getPresenters: searchTerm => {

            dispatch(presenterActions.searchPresenters(searchTerm));
        },
        getPacks: searchTerm => {

            dispatch(resourcePackActions.searchPacks(searchTerm));
        }
    }
}

export default reduxForm(reduxFormParams, mapStateToProps, mapDispatchToProps)(CSSModules(EventForm, style));


// WEBPACK FOOTER //
// ./components/EventForm/index.js